import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

import {CarrinhoService} from "../services/carrinho.service";
import {PedidoLoja} from "../objeto/PedidoLoja";
import {ProdutoService} from "../services/produto.service";
import {ITela} from "../objeto/ITela";
import {ConstantsService} from "../services/ConstantsService";
import {ClienteService} from "../services/cliente.service";
import {DominiosService} from "../services/dominios.service";
import {DeviceDetectorService} from "ngx-device-detector";
import {
  DialogCloseResult,
  DialogRef,
  DialogService,
  WindowCloseResult,
  WindowRef,
  WindowService
} from "@progress/kendo-angular-dialog";
import {Location} from "@angular/common";
import {SiteProdutoComponent} from "../site-produto/site-produto.component";
import {SiteMontarpizzaComponent} from "../site-montarpizza/site-montarpizza.component";
import {AutorizacaoLojaService} from "../services/autorizacao-loja.service";
import {BannerService} from "../services/banner.service";
import {PopupUtils} from "../objeto/PopupUtils";
import {PopupEnderecoChinaInboxComponent} from "../app/popup-endereco-china-inbox/popup-endereco-china-inbox.component";
import {HttpClient} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {Observable, of, Subscription} from "rxjs";
import {SharedDataService} from "../services/shared.data.service";
import {FormaDeEntrega} from "../objeto/FormaDeEntrega";
import {Endereco} from "../objeto/Endereco";
import {SiteWizardProdutosIaComponent} from "../app/produtos/site-wizard-produtos-ia/site-wizard-produtos-ia.component";

declare var _;
declare var $;

@Component({
  selector: 'app-produtos',
  templateUrl: './site-produtos.component.html',
  styleUrls: ['./site-produtos.component.scss']
})
export class SiteProdutosComponent implements OnInit, ITela, AfterViewInit, OnDestroy {
  @ViewChild('tabs', {static: false}) tabs: any;
  @ViewChild('divProdutos', {static: false}) divProdutos: any;

  @ViewChild('megamenu', {static: false}) megamenu: ElementRef;
  @ViewChild('wraper', {static: false})   wraper: ElementRef;

  produtos = [];
  vitrines = [];
  ultimosPratos = [];
  carregou: boolean;
  mensagemErro = '';
  pedido: PedidoLoja;
  carregando: boolean;
  categorias: any  = [];
  produtosPorCategoria: any = {}
  nomePagina: string;
  isMobile: any;
  observer: IntersectionObserver;
  estaFazendoScroll: boolean;
  window: DialogRef;
  codigoProduto: any;
  idTamanho: any;
  indiceProduto: any;
  codigopromo: any;
  hashMesa: string;
  mesaExpirada: boolean;
  layoutHorizontal: boolean;
  exibirMegaMenu: boolean
  larguraProdutos: number;
  empresa: any
  categoriasMegamenu: any;
  exibirVerMaisMegamenu = false;
  deslocamento = 0
  exibirMenuMobile = false;
  qtdeMaxima: number;
  movendo: boolean;
  categoriaMonteSuaPizza = {
    id: 1,  nome: ''
  };
  destaques =  [];
  nomeCategoriaDestaque = 'DESTAQUES';
  categoriaDestaque = {
    id: 2,
    nome: this.nomeCategoriaDestaque
  };
  alturaBanner = 230;

  banners = [];
  exibirPrecos = true;
  apiLoaded: Observable<boolean>;

  assinatura: Subscription;
  colunasMenu: any = {};
  evtEmpresa: Subscription;
  evtEmpresa2: Subscription;

  empresasDoGrupo = [];
  multiPedido = false;
  solicitandoGarcom: boolean;
  solicitandoFechar: boolean;
  mensagemSucessoGarcom: string;
  timerSolicitarGarcomNovamente: number;
   timerSolicitarFecharNovamente: number;

   ids = '';

  constructor(private router: Router, private sanitizer: DomSanitizer, private clienteService: ClienteService,
              private produtoService: ProdutoService, private carrinhoService: CarrinhoService,
              private autorizacaoLojaService: AutorizacaoLojaService, public sharedDataService: SharedDataService,
              private activatedRoute: ActivatedRoute, private constantsService: ConstantsService,
              private dominiosService: DominiosService, private detectorDevice: DeviceDetectorService,
              private dialogService: DialogService, private location: Location, private bannerService: BannerService,
              private httpClient: HttpClient) {
    this.nomePagina = dominiosService.obtenhaRaizCardapio();
    this.isMobile = this.detectorDevice.isMobile();
    this.hashMesa = this.activatedRoute.snapshot.params.hm;
    this.codigopromo = this.activatedRoute.snapshot.params.codigopromo;
    this.dominiosService.hashMesa = this.hashMesa

    document.body.classList.add("ativar_fundo_tema");

    if( this.isMobile ) {
      this.alturaBanner = 100;
    }

    if(window['multipedido']) {
      this.multiPedido = true;
      const  tipoCardapio = (this.hashMesa || (this.pedido && this.pedido.mesa )) ? 'MESA' : 'DELIVERY';

      this.produtoService.listeAhVendaGrupo(tipoCardapio, false).subscribe( (empresas: any) => {
        this.empresasDoGrupo = empresas;
      });
    }

    this.apiLoaded = this.httpClient.jsonp('https://maps.googleapis.com/maps/api/js?' +
      'key=AIzaSyBlPtg98e0hBo0JJSYMB3R7iakhFe_iT4o&callback=initMap&libraries=&v=weekly', 'callback').pipe(
      map(() => {
        console.log('chamando');
        return true
      }),
      catchError((error) => {
        console.log(error);
        return of(false);
      }),
    );

    this.inicializePedido().then(() => {
      this.activatedRoute.queryParams.subscribe(params => {

        if( params['ids'] ) {
          this.ids = params['ids'];
        }
        if( params['nl']  )
          this.autorizacaoLojaService.atualizeUsuarioLogado().then(  () => {});

        if( params['c'] ) {
          this.codigoProduto = parseInt(params['c'], 10);
          if( isNaN(this.codigoProduto) )
            this.codigoProduto = null;
        }

        if( params['t'] ) {
          this.idTamanho = parseInt(params['t'], 10);
          if( isNaN(this.idTamanho) )
            this.idTamanho = null;
        }
        if( params['e'] ) {

          this.indiceProduto = parseInt(params['e'], 10);

          if( isNaN(this.indiceProduto) ) {
            this.indiceProduto = null;
          } else {
            this.indiceProduto = this.indiceProduto + '';
          }
        }
      });

      if (this.codigopromo)
        this.carrinhoService.atualizeValorDesconto(this.codigopromo, this.empresa, true).then( () => {});
    });

    this.sharedDataService.exibirMenu.subscribe(exibir => {
      this.exibirMenuMobile = exibir;
    });
  }

  public static abraPedindoEndereco(siteProdutos: SiteProdutosComponent, router: Router, location: Location, activatedRoute: ActivatedRoute,
                                    dialogService: DialogService, isMobile: boolean) {
    let dimensao = PopupUtils.calculeAlturaLarguraMenor(isMobile)

    const windowRef: DialogRef = dialogService.open({
      title: null,
      content: PopupEnderecoChinaInboxComponent,
      minWidth: 250,
      width: dimensao.largura,
      maxHeight: dimensao.altura,
      height: 'auto'
    });

    let telaProduto: PopupEnderecoChinaInboxComponent = windowRef.content.instance;

    let params: any = {
    };

    telaProduto.window = windowRef;

    PopupUtils.abraJanela(router,  location, activatedRoute, windowRef, params);

    windowRef.result.subscribe((result: any) => {
      if( siteProdutos ) siteProdutos.exibirPrecos = true;
    });

    return windowRef;
  }

  ngAfterViewInit(): void {
    this.activatedRoute.queryParams.subscribe( (params) => {
      this.evtEmpresa2 = this.constantsService.empresa$.subscribe((empresa) => {
        if (!empresa) {
          return
        }

        this.empresa = empresa;

        const pedido: PedidoLoja = this.carrinhoService.obtenhaPedido();

        if( params.end ) {
          const endereco = Endereco.novo();
          Object.assign(endereco, JSON.parse(decodeURI(params.end)))

          this.pedido.entrega.formaDeEntrega = FormaDeEntrega.RECEBER_EM_CASA;
          this.pedido.entrega.setTaxaEntrega(endereco, null);
          this.carrinhoService.salvePedido(this.pedido);
        }

        const formaReceberEmCasa = this.obtenhaFormaDeEntregaReceberEmCasa(empresa);

        if (formaReceberEmCasa && formaReceberEmCasa.perguntarEnderecoInicio ) {
          if (!empresa.integracaoDelivery) {
            this.mensagemErro = 'Integração com Eclética tem que estar configurada';
          }

          if ((!pedido.entrega || !pedido.entrega.formaDeEntrega)) {
            this.exibirPrecos = false;
            SiteProdutosComponent.abraPedindoEndereco(this, this.router,
              this.location, this.activatedRoute, this.dialogService, this.isMobile);
          }
        }

        if (empresa.nomeCategoriaDestaques) {
          let nomeAnterior = this.categoriaDestaque.nome
          this.categoriaDestaque.nome = empresa.nomeCategoriaDestaques;
          this.produtosPorCategoria[this.categoriaDestaque.nome] = this.produtosPorCategoria[nomeAnterior]
        }

        this.bannerService.obtenhaBanners().then((banners) => {
          for (let i = 0; i < banners.length; i++) {
            const banner = banners[i];

            banner.thumbImage = banner.image = 'https://promokit.com.br/images/empresa/' + banner.linkImagem;
          }

          this.banners = banners;
        })

        this.layoutHorizontal = empresa.tipoDeLoja === 'MERCADO' || empresa.tipoDeLoja === 'ECOMMERCE';

        if (this.layoutHorizontal) {
          this.qtdeMaxima = 25;
        }

        if (this.layoutHorizontal) {
          if (this.isMobile) {
            this.larguraProdutos = ((this.divProdutos.nativeElement.clientWidth - 20) / 2);
          } else {
            this.larguraProdutos = ((this.divProdutos.nativeElement.clientWidth - 40) / 4);
          }
        }
      });
    });
  }

  obtenhaFormaDeEntregaReceberEmCasa(empresa: any) {
    return empresa.formasDeEntrega.find( (forma) => {
      return forma.formaDeEntrega.nome === 'Receber em casa'
    });
  }

  ngOnDestroy(): void {
    this.evtEmpresa.unsubscribe();
    this.evtEmpresa2.unsubscribe();

    document.body.classList.remove("ativar_fundo_tema");
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if( this.window ) {
      this.window.close({
        back: true
      });
    }
  }

  abraDetalhesProduto(produto: any, indiceProduto: any = null) {
    if(!produto.montar){
      this.window = SiteProdutoComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.isMobile, produto, indiceProduto);
    } else {
      this.window =  SiteMontarpizzaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.isMobile, produto, indiceProduto);
    }
  }

  abraDetalhesPrato(itemPedido: any){
    this.window = SiteProdutoComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
      this.dialogService, this.isMobile, itemPedido.produto, null, itemPedido);
  }

  obtenhaTipoCardapio(){
    return (this.hashMesa || (this.pedido && this.pedido.mesa )) ? 'MESA' : 'DELIVERY' ;
  }

  ngOnInit() {
    this.carregando = true;
    this.evtEmpresa = this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) { return }

      this.exibirMegaMenu = empresa.tipoDeLoja === 'ECOMMERCE';
      this.layoutHorizontal = empresa.tipoDeLoja === 'MERCADO' || empresa.tipoDeLoja === 'ECOMMERCE';

      if(  this.exibirMegaMenu ){
        this.produtoService.listeCategoriasMegamenu().then( (categoriasMegamenu) => {
          this.categoriasMegamenu = categoriasMegamenu;
          this.setColunasMegaMenu();
        }).catch(erro => {
          console.log(erro)
        })
      }

      this.produtoService.listeProdutosVitrine().then( (vitrines: any) => {
        this.vitrines = vitrines || [];

        if(this.vitrines.length &&  this.exibirMegaMenu ) {
          this.carregando = false;
          this.definaCategoriasFixas();
          return;
        }

        const  tipoCardapio =  this.obtenhaTipoCardapio();

        if(window.history.state.fezLogin)
          this.produtoService.removaDaCache(empresa, tipoCardapio);

        this.produtoService.listeAhVenda(empresa, tipoCardapio, this.layoutHorizontal).subscribe( (respota: any) => {
          this.produtos = respota.produtos;
          this.categorias = respota.categorias;

          this.ultimosPratos = [];

          if(respota.ultimosPratos){
            respota.ultimosPratos.forEach((itemPedido: any) => {
              //  produtoPedirNovamente.destacado = true;
              this.ultimosPratos.push(itemPedido);
            })
          }

          debugger;
          //filtrar os produtos por ids
          if(this.ids) {
            let dimensao = PopupUtils.calculeAlturaLargura(this.isMobile);

            const windowRef: DialogRef = this.dialogService.open({
              title: null,
              content: SiteWizardProdutosIaComponent,
              minWidth: 250,
              width: dimensao.largura,
              height: dimensao.altura
            });

            let telaProduto: SiteWizardProdutosIaComponent = windowRef.content.instance;
            telaProduto.ids = this.ids;
            telaProduto.categorias = this.categorias;
            telaProduto.produtos = this.produtos;
            telaProduto.window = windowRef;

            telaProduto.processe();

            PopupUtils.abraJanela(this.router, this.location, this.activatedRoute,
              windowRef, {}, null, 'dialog-produto-ia');

/*

            const items = this.ids.split('|');


            const novasCategorias = [];

            items.forEach((item) => {
              // Dividir cada item pela ":" para separar o nome do produto e os IDs
              const [product, idsStr] = item.split(':');

              // Dividir os IDs pela "," para separar os IDs
              const ids = idsStr.split(',');

              const categoriaEncontrados = {
                id: ids.join(':'),
                nome: product,
                destaque: true,
                ia: true
              };

              produtosEncontrados = ids.map( (id) => {
                return this.produtos.find((produto => produto.id.toString() === id));
              }).filter((produto) => produto != null);

              produtosEncontrados.forEach(produtoEncontrado => {
                const index = this.produtos.indexOf(produtoEncontrado);
                if (index !== -1) {
                  this.produtos.splice(index, 1);
                }
              });

              this.produtos.push(...produtosEncontrados);

              novasCategorias.push(categoriaEncontrados);

              produtosEncontrados.forEach( (produto) => {
                produto.categoria = categoriaEncontrados;
              });
            });

            this.categorias.unshift(...novasCategorias);
            /*
            produtosEncontrados = this.produtos.filter( (produto) => {
              return ids.includes(produto.id.toString())
            });

            produtosEncontrados.forEach( (produto) => {
              produto.categoria = categoriaEncontrados;
            });
             */

          }

          this.constantsService.produtosLoja = this.produtos;

          if( this.layoutHorizontal ) {
            for (let i = 0; i < this.produtos.length; i++) {
              const produto = this.produtos[i];
              produto.destacado = true;
            }
          }

          this.produtosPorCategoria = _.groupBy(this.produtos, produto => produto.categoria ? produto.categoria?.nome?.trim() : 'Outros')

          this.definaCategoriasFixas();

          this.carregando = false;

          if( this.codigoProduto ) {
            const produto = this.obtenhaProduto(this.codigoProduto);
            this.abraDetalhesProduto(produto, this.indiceProduto);
          } else if (this.idTamanho){
            let produtoCategoria =
              this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome].find( produtoCategogia => produtoCategogia.id === this.idTamanho);

            this.abraDetalhesProduto(produtoCategoria, this.indiceProduto);
          }

          this.assinatura = this.activatedRoute.params.subscribe( (params2) => {
            const idCategoria = params2.idc;

            if(idCategoria){
              const categoria = this.categorias.find((cat: any) => cat.id === Number(idCategoria))

              if( categoria ) {
                setTimeout( () => {
                  this.selecionou(categoria);
                  this.assinatura.unsubscribe();
                }, 1000);
              }
            }
          });
        });
      });
    });
  }

  obtenhaProduto(id: number) {
   return this.produtos.find( produto => produto.id === id)
  }

  getPosicao(nomeCategoria){
    let _produto = this.produtos.find( produto => produto.categoria && produto.categoria.nome.trim() === nomeCategoria.trim())

    let posicao = _produto ? _produto.categoria.posicao : this.produtos.length;

    return posicao;
  }

  deveExibirTopo() {
    return true;
  }

  deveExibirMenu(){
    return true;
  }

  abraTelaDeBusca() {
    const params = {state: {produtos: this.produtos,
        produtosPorCategoria: this.produtosPorCategoria, categorias: this.categorias,
      ehMesa: (this.hashMesa || (this.pedido && this.pedido.mesa ))}};

    let link = String(`/${this.nomePagina}/busca`);

    if(this.empresa.layoutEcommerce){
      link += '/ecommerce/todos'
      params.state.categorias = this.categoriasMegamenu;
    }


    this.router.navigateByUrl(link, params).then( () => { });
  }

  abraTelaBuscaCategoria(categoria: any) {

    this.sharedDataService.exibirMenuMobile = false;

    this.router.navigateByUrl('/busca/ecommerce/' + categoria.id,
      {state: { categoria: categoria, categorias: this.categoriasMegamenu }  });

    return false;
  }

  abraTelaBuscaPorCategoria(categoria) {
    if(this.empresa && this.empresa.layoutEcommerce){
      this.abraTelaBuscaCategoria(categoria)
    } else {
      const produtos = this.produtosPorCategoria[categoria.nome];
      const mapProdutosPorCategoria = {};

      mapProdutosPorCategoria[categoria.nome] = produtos;

      const state = {state: {produtos: produtos,
          produtosPorCategoria: mapProdutosPorCategoria, categorias: [categoria],
          ehMesa: (this.hashMesa || (this.pedido && this.pedido.mesa ))}};

      this.router.navigateByUrl('/busca?c=' + categoria.nome, state).then( () => {});
    }

    return false;
  }

  voltar() {

  }


  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }

  selecionou(categoria) {
    const idTab = 'tab_' + categoria.nome;
    const nomeCategoria = categoria.nome;

    this.posicioneTab(idTab);

    this.posicioneConteudo(nomeCategoria);

    this.tabs.select(idTab);
    let novaUrl = '/categoria/' +
      categoria.nome.toLowerCase().replace(/\s+/g, "-") + '/' + categoria.id + window.location.search;

    // this.location.replaceState(novaUrl);
    window.history.pushState({path: novaUrl}, '', novaUrl);
  }

  posicioneTab(categoria) {
    categoria = categoria.trim();
    const tab = document.getElementById(categoria);

    if(tab){
      const $tabs = $("#tabs.nav-tabs");
      const posicao = tab.offsetLeft - ($tabs.width() / 2) + (tab.getBoundingClientRect().width / 2);

      $tabs.animate({scrollLeft: posicao}, 100);
    }

  }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event){
    if( this.estaFazendoScroll ) {
      return;
    }

    const tabs = document.querySelectorAll('.categoria');

    for( let i = tabs.length - 1; i >= 0; i-- ) {
      const tab: any = tabs[i];

      const topElemento = this.getOffset(tab).top;
      const posicaoY = topElemento - document.querySelector('.header').clientHeight - 50;

      if( window.scrollY >= posicaoY ) {
        const idTab = 'tab_' + tab.innerText;

        if( this.tabs && this.tabs.activeId !== idTab ) {
          this.tabs.select(idTab);
          this.posicioneTab('tab_' + tab.innerText);
        }
        break;
      }
    }
  }

  posicioneConteudo(categoria) {
    categoria = categoria.trim();
    const topElemento = this.getOffset(document.getElementById(categoria)).top;
    const y = topElemento - document.querySelector('.header').clientHeight - 20;

    this.estaFazendoScroll = true;

    let posicao = -1;

    const chequeScroll = () => {
      if( posicao !== window.scrollY ) {
        posicao = window.scrollY;

        setTimeout(chequeScroll, 100);
        return;
      }

      this.estaFazendoScroll = false;
    }

    setTimeout(chequeScroll, 100);

    window.scroll({
      top: y,
      behavior: 'smooth'
    });
  }

  mudeAba() {
  }

  exibirUnidade(produto: any) {
    return produto.tipoDeVenda && produto.tipoDeVenda === 'Peso'
  }

  private inicializePedido() {
    return new Promise((resolve) => {
      if(this.hashMesa) {
        this.carrinhoService.obtenhaMesa(this.hashMesa).then((mesa: any) => {
          if(!mesa){
            this.mesaExpirada = true;
          } else {
            mesa.hash  = this.hashMesa;
            this.pedido = this.carrinhoService.obtenhaPedido(mesa)
            resolve(null);
          }
        })
      } else {
        this.pedido = this.carrinhoService.obtenhaPedido();
        resolve(null);
      }
    })
  }

  moverScrollDireita(scroll: HTMLDivElement, categoria: HTMLDivElement) {
    if( this.movendo ) return;

    const posicao = scroll.scrollLeft;

    let largura = categoria.clientWidth;

    if( this.isMobile ) {
      largura = this.larguraProdutos + 10;
    }

    const novaPosicao = posicao + largura;

    this.movendo = true;
    scroll.scroll({
      left: novaPosicao,
      behavior: 'smooth'
    });

    categoria.classList.add('moveu');

    setTimeout( () => {
      this.movendo = false;

      const scrollWidth = scroll.scrollWidth;
      if (scrollWidth - largura === novaPosicao) {
        categoria.classList.add('scroll_fim');
      }
    }, 500);
  }

  moverScrollEsquerda(scroll: HTMLDivElement, categoria: HTMLDivElement) {
    if( this.movendo ) return;

    categoria.classList.remove('scroll_fim');

    const posicao = scroll.scrollLeft;

    let largura = categoria.clientWidth;

    if( this.isMobile ) {
      largura = this.larguraProdutos + 10;
    }


    let novaPosicao = posicao - largura;
    if( novaPosicao < 0 ) {
      novaPosicao = 0;
    }

    this.movendo = true;
    scroll.scroll({
      left: novaPosicao,
      behavior: 'smooth'
    });

    setTimeout( () => {
      if( novaPosicao === 0 ) {
        categoria.classList.remove('moveu');
      }
      this.movendo = false;
    }, 500);
  }

  private insiraCategoriaFixa(categoria: any , produtos: any){
    if(!this.categorias.find(item =>  item.id === categoria.id )){
      this.categorias.splice(0, 0, categoria);
    }

    this.produtosPorCategoria[categoria.nome] = produtos;
  }

  private definaCategoriasFixas() {
    let pizzasMontar: any =
      this.produtos.filter( produto => produto.template != null && produto.template.montarPizza);

    if(pizzasMontar.length > 0){
      this.categoriaMonteSuaPizza.nome = pizzasMontar[0].template.nomeCategoriaMontar;
      this.insiraCategoriaFixa(this.categoriaMonteSuaPizza, []);

      pizzasMontar.forEach( (produtoPizza: any) => {
        produtoPizza.tamanhos.forEach( (tamanhoPizza: any) => {

          if(tamanhoPizza.qtdeSabores >= 1){

            let nome = String(`${produtoPizza.template.nome} ${tamanhoPizza.descricao} `),
              descricao = String(`Monte ${nome}`),
              preco = tamanhoPizza.novoPreco ? tamanhoPizza.novoPreco : tamanhoPizza.preco;

            if(tamanhoPizza.qtdeSabores > 1){
              nome = String(`${nome} com até  ${tamanhoPizza.qtdeSabores} sabores`)
              descricao = String(`${descricao} com até  ${tamanhoPizza.qtdeSabores} sabores`)
            }



            let produtoCategoria =
              this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome].find(
                produtoCategogia => produtoCategogia.id === tamanhoPizza.template.id);

            if(!produtoCategoria){
              produtoCategoria =  {
                id: tamanhoPizza.template.id, nome: nome,    descricao: descricao, montar: true,
                template: produtoPizza.template, tamanho: tamanhoPizza, valorMinimo: preco,
                sabores: [], camposAdicionais: produtoPizza.camposAdicionais, tamanhos: [],
              }
              this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome].push( produtoCategoria);
            }

            produtoCategoria.sabores.push(produtoPizza);

            if(produtoCategoria.preco < preco)
              produtoCategoria.valorMinimo = preco
          }


        })
      })

    }
    this.destaques = [];

    this.produtos.forEach( (produto: any) => {
      if(produto.destaque) this.destaques.push(Object.assign({}, produto))

      if(produto.tamanhos && produto.tamanhos.length){
        if(produto.tamanhos.find( tamanho => tamanho.destaque) != null)
          this.destaques.push(Object.assign({}, produto))
      }
    })

    this.destaques.forEach( produto => produto.destacado = true);

    if( this.destaques.length)
      this.insiraCategoriaFixa( this.categoriaDestaque,  this.destaques)

    for(let i = this.vitrines.length - 1; i >= 0 ; i--){
      let vitrine: any =  this.vitrines[i];
      let categoriaVitrine: any =  { nome: vitrine.nome, id: vitrine.id, vitrine: true };

      let produtosVitrine = vitrine.produtosNaVitrine.map((pnv: any) => pnv.produto);
      produtosVitrine.forEach( produto => produto.destacado = true);

      this.insiraCategoriaFixa(categoriaVitrine, produtosVitrine)
    }

  }

  clicouBanner(indice: any) {
    const banner = this.banners[indice];

    if( banner.comando === 'LINK' ) {
      window.open(banner.extra);
    } else if( banner.comando === 'BUSCA' ) {
      const state = {state: {produtos: this.produtos,
          produtosPorCategoria: this.produtosPorCategoria, categorias: this.categorias}};

      this.router.navigateByUrl('/' + this.nomePagina + '/busca?q=' + banner.extra, state).then( () => {

      });
    }
  }

  deveTerBordas() {
    return true;
  }

  fecheMenuCategorias() {
    this.sharedDataService.exibirMenuMobile = false;
    return false;
  }



  private setColunasMegaMenu() {

    for(let categoria of this.categoriasMegamenu){
       this.colunasMenu[categoria.id] = {
          coluna1: { total: 0, subcategorias: []},
          coluna2: { total: 0, subcategorias: []},
          coluna3: { total: 0, subcategorias: []}
      }

      for(let i = 0 ; i <  categoria.subcategorias.length; i++){
        let item: any = this.colunasMenu[categoria.id];

        let coluna: any = this.obtenhaMaisVazia(item.coluna1, item.coluna2, item.coluna3)
        let subcategoria = categoria.subcategorias[i];
        coluna.subcategorias.push(subcategoria)

        let total = 1 + subcategoria.subcategorias.length;

        coluna.total += total; //so exibi 8 itens da subcategoria na tela
      }
    }
  }

  private obtenhaMaisVazia(categoriasColuna1: any, categoriasColuna2: any, categoriasColuna3: any){
    if(categoriasColuna1.total <= categoriasColuna2.total &&  categoriasColuna1.total <= categoriasColuna3.total )
      return categoriasColuna1;

    if(categoriasColuna2.total <= categoriasColuna3.total)
      return categoriasColuna2;


    return categoriasColuna3;
  }


  getColunas(categoria: any): any{
    return this.colunasMenu[categoria.id];
  }

  deveExibirBannerTema() {
    return true;
  }

  scrollParaDireita() {

    let tamanhoTotal = 0;

    for(let i = 0; i <  this.wraper.nativeElement.firstChild.children.length; i++)
      tamanhoTotal += this.wraper.nativeElement.firstChild.children[i].offsetWidth;

    let maximoScroll = tamanhoTotal - this.wraper.nativeElement.offsetWidth

    if(this.deslocamento <= maximoScroll  ) {
      this.deslocamento += 200;
    }
  }

  scrollParaEsquerda(){
    this.deslocamento -= 200;
    if(this.deslocamento  < 0 )
      this.deslocamento  = 0;

  }

  marginLeft(){
    return String(`-${this.deslocamento}px`);
  }

  paddingLeft(){ //padding-left
    return String(`${this.deslocamento}px`);
  }

  solicitouFecharMesa() {
    this.solicitandoFechar = true;

    this.carrinhoService.soliciteFecharMesa().then((resultado: any) => {
      this.timerSolicitarFecharNovamente = 180;

      this.inicieTimerSolicitarFecharNovamente()


      this.mensagemSucessoGarcom = 'Foi solicitado fechar a conta.'

    })

  }


  solicitouGarcom() {
    this.solicitandoGarcom = true;

    this.carrinhoService.soliciteGarcom().then((resultado: any) => {
      this.timerSolicitarGarcomNovamente = 180;

      this.inicieTimerSolicitarGarcomNovamente()

      this.mensagemSucessoGarcom = 'Garçom solicitado com sucesso.'

    })

  }

  fecheMensagemSucessoGarcom() {
    this.mensagemSucessoGarcom = null;
  }

  private inicieTimerSolicitarGarcomNovamente() {
    setTimeout(() => {
        this.timerSolicitarGarcomNovamente--;

        if (this.timerSolicitarGarcomNovamente > 0)
          this.inicieTimerSolicitarGarcomNovamente();
        else
          this.solicitandoGarcom = false;
          },
      1000)
  }

  private inicieTimerSolicitarFecharNovamente() {
    setTimeout(() => {
        this.timerSolicitarFecharNovamente--;

        if (this.timerSolicitarFecharNovamente > 0)
          this.inicieTimerSolicitarFecharNovamente();
        else
          this.solicitandoFechar = false;
      },
      1000)
  }

}
